import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import sharedEN from './locales/en/shared.json'
import sharedKR from './locales/kr/shared.json'
import aboutEN from './locales/en/about.json'
import aboutKR from './locales/kr/about.json'
import testimonialsEN from './locales/en/testimonials.json'
import testimonialsKR from './locales/kr/testimonials.json'
import projectsEN from './locales/en/projects.json'
import projectsKR from './locales/kr/projects.json'
import blogEN from './locales/en/blog/blog.json'
import blogKR from './locales/kr/blog/blog.json'
import yearEndEN from './locales/en/blog/yearEnd.json'
import yearEndKR from './locales/kr/blog/yearEnd.json'
import smartThingsEN from './locales/en/blog/smartThings.json'
import smartThingsKR from './locales/kr/blog/smartThings.json'
import faqEN from './locales/en/faq.json'
import faqKR from './locales/kr/faq.json'
import qnaER from './locales/en/qna.json'
import qnaKR from './locales/kr/qna.json'
import mainEN from './locales/en/main.json'
import mainKR from './locales/kr/main.json'
import booksEN from './locales/en/books.json'
import booksKR from './locales/kr/books.json'
import organizeThoughtsEN from './locales/en/blog/organizeThoughts.json'
import organizeThoughtsKR from './locales/kr/blog/organizeThoughts.json'
import engineerToPMEN from './locales/en/blog/engineerToPM.json'
import engineerToPMKR from './locales/kr/blog/engineerToPM.json'
import twoCountriesTwoLivesEN from './locales/en/blog/two-countries-two-lives.json'
import twoCountriesTwoLivesKR from './locales/kr/blog/two-countries-two-lives.json'
import twoLanguageEN from './locales/en/blog/twoLanguage.json'
import twoLanguageKR from './locales/kr/blog/twoLanguage.json'
import connectionsEN from './locales/en/blog/connections.json'
import connectionsKR from './locales/kr/blog/connections.json'
import palantirRedefiningTheProblemEN from './locales/en/blog/palantirRedefiningTheProblem.json'
import palantirRedefiningTheProblemKR from './locales/kr/blog/palantirRedefiningTheProblem.json'
import dataIsTheOxygenOfAiEN from './locales/en/blog/dataIsTheOxygenOfAi.json'
import dataIsTheOxygenOfAiKR from './locales/kr/blog/dataIsTheOxygenOfAi.json'
import familyEN from './locales/en/blog/family.json'
import familyKR from './locales/kr/blog/family.json'
import beforeThirtyEN from './locales/en/blog/beforeThirty.json'
import beforeThirtyKR from './locales/kr/blog/beforeThirty.json'
import listeningOverSpeakingEN from './locales/en/blog/listeningOverSpeaking.json'
import listeningOverSpeakingKR from './locales/kr/blog/listeningOverSpeaking.json'
import goodDataFromPipelineEN from './locales/en/blog/goodDataFromPipeline.json'
import goodDataFromPipelineKR from './locales/kr/blog/goodDataFromPipeline.json'
import paradoxOfClosenessEN from './locales/en/blog/paradoxOfCloseness.json'
import paradoxOfClosenessKR from './locales/kr/blog/paradoxOfCloseness.json'
import choiceEN from './locales/en/blog/choice.json'
import choiceKR from './locales/kr/blog/choice.json'
import placeToReturnEN from './locales/en/blog/placeToReturn.json'
import placeToReturnKR from './locales/kr/blog/placeToReturn.json'
import memoryOfSeasonEN from './locales/en/blog/memoryOfSeason.json'
import memoryOfSeasonKR from './locales/kr/blog/memoryOfSeason.json'
// the translations
const resources = {
  en: {
    about: aboutEN,
    shared: sharedEN,
    testimonials: testimonialsEN,
    projects: projectsEN,
    blog: blogEN,
    yearEnd: yearEndEN,
    smartThings: smartThingsEN,
    faq: faqEN,
    qna: qnaER,
    main: mainEN,
    books: booksEN,
    organizeThoughts: organizeThoughtsEN,
    engineerToPM: engineerToPMEN,
    twoCountriesTwoLives: twoCountriesTwoLivesEN,
    twoLanguage: twoLanguageEN,
    connections: connectionsEN,
    palantirRedefiningTheProblem: palantirRedefiningTheProblemEN,
    dataIsTheOxygenOfAi: dataIsTheOxygenOfAiEN,
    family: familyEN,
    beforeThirty: beforeThirtyEN,
    listeningOverSpeaking: listeningOverSpeakingEN,
    goodDataFromPipeline: goodDataFromPipelineEN,
    paradoxOfCloseness: paradoxOfClosenessEN,
    choice: choiceEN,
    placeToReturn: placeToReturnEN,
    memoryOfSeason: memoryOfSeasonEN
  },
  kr: {
    about: aboutKR,
    shared: sharedKR,
    testimonials: testimonialsKR,
    projects: projectsKR,
    blog: blogKR,
    yearEnd: yearEndKR,
    smartThings: smartThingsKR,
    faq: faqKR,
    qna: qnaKR,
    main: mainKR,
    books: booksKR,
    organizeThoughts: organizeThoughtsKR,
    engineerToPM: engineerToPMKR,
    twoCountriesTwoLives: twoCountriesTwoLivesKR,
    twoLanguage: twoLanguageKR,
    connections: connectionsKR,
    palantirRedefiningTheProblem: palantirRedefiningTheProblemKR,
    dataIsTheOxygenOfAi: dataIsTheOxygenOfAiKR,
    family: familyKR,
    beforeThirty: beforeThirtyKR,
    listeningOverSpeaking: listeningOverSpeakingKR,
    goodDataFromPipeline: goodDataFromPipelineKR,
    paradoxOfCloseness: paradoxOfClosenessKR,
    choice: choiceKR,
    placeToReturn: placeToReturnKR,
    memoryOfSeason: memoryOfSeasonKR
  }
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    defaultNS: 'shared',
    lng: localStorage.getItem('lng') || 'en',
    fallbackLng: 'en',

    // keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n
